module.exports = __webpack_public_path__ + "media/images/oficinas/concepcion-c789d878a9a81e9c5ab7064fd569095b.jpg";